// Echte Google-Rezensionen von Dickies-Campus (manuell gepflegt, Stand: Juni 2026).
// Quelle: Google Maps Unternehmensprofil – bitte bei neuen Top-Rezensionen ergänzen.
export const GOOGLE_PROFILE_URL =
  "https://www.google.com/maps/search/?api=1&query=Dickies%20Helden";

export const GOOGLE_REVIEWS = [
  {
    id: "tatjana-s",
    author: "Tatjana Scharnowski",
    meta: "Local Guide · 54 Rezensionen",
    time: "vor 4 Monaten",
    rating: 5,
    text: "Ich habe eine Weiterbildung bei Dickies-Campus gemacht und kann sagen, dass ich hervorragend betreut wurde. Viel und ausführliches Material, jederzeit konnten wir uns für offene Fragen melden und Annika Lorke ist eine offene, sympathische Person. Sie hat uns wunderbar betreut und durch die Prüfung gebracht. Vielen Dank dafür.",
  },
  {
    id: "anna-c",
    author: "Anna Crispo",
    meta: "1 Rezension",
    time: "vor 5 Monaten",
    rating: 5,
    text: "Ganz tolles Team bei Dickies-Campus. Wirklich nur zu empfehlen, dort die Weiterbildung oder ähnliches zu absolvieren. Sehr freundliches Entgegenkommen, schnelles Bearbeiten von Unterlagen, die man benötigt. Sehr tolerant, sympathisch und geduldig. Jede offene Frage wird beantwortet. Die Dozentinnen, die ich kennenlernen durfte: sehr sympathisch und verständnisvoll. Für alles eine Lösung. Der Inhalt der Weiterbildung wurde top weitergegeben, sodass man auch als kompletter Neuling in dem Berufsfeld alles versteht und erlernen kann. Ich habe mit voller Punktzahl bestanden und hatte vor dem Kurs null Ahnung.",
  },
  {
    id: "iwin-h",
    author: "Iwin Holdings",
    meta: "1 Rezension",
    time: "vor 2 Monaten",
    rating: 5,
    text: "Frau Annika und Frau Julia von „Dickies-Campus“ sind außergewöhnliche Dozentinnen. Durch ihre fundierte Analyse, ihre durchgängige Motivation und ihre wertschätzende Art haben sie uns nicht nur fachlich weitergebracht, sondern uns gestärkt und zu echten Helden in der Pflege gemacht. Meine klare Empfehlung, vielen Dank für diese bereichernde Erfahrung.",
  },
  {
    id: "dominik-g",
    author: "Dominik Goldkuhle",
    meta: "Local Guide · 19 Rezensionen",
    time: "vor 3 Monaten",
    rating: 5,
    text: "Ich bin total begeistert, so liebevoll wie man begleitet wird. Angst braucht man hier nicht haben.",
  },
  {
    id: "jessica-b",
    author: "Jessica Bauer",
    meta: "2 Rezensionen",
    time: "vor 5 Monaten",
    rating: 5,
    text: "Ich kann Dickies-Campus nur empfehlen. Die Dozentin Annika erklärt alles super, macht einen sehr guten Unterricht. Alles super gelaufen – es sind alles 5 Sterne.",
  },
];
